"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _d3Format = require("d3-format");
/**
 * We apply a naive heuristic here to guess the best way to format a number or do
 * nothing if the value is a string.
 */
var defaultNumberFormatter = function defaultNumberFormatter(value) {
  var coercedValue = +value;

  /** If value is not numerical then do nothing. */
  if (isNaN(coercedValue)) {
    console.warn('defaultNumberFormatter(): Was expecting a numeric value but ' + // eslint-disable-line
    "received a ".concat((0, _typeof2["default"])(value), ". This is a no-op but could incorrect props passed to chart. Input: "), value);
    return value;
  }

  /** Uses scientific notation with three significant digits, trimming insignificant zeros */
  var insignificantZeroMatcher = new RegExp(/(\.[1-9]*)0+(?=[a-zA-Z])/);
  var insignificantDecimalMatcher = new RegExp(/\.(?=[a-zA-Z])/);
  if (coercedValue > 999) {
    // Using the coerced value keeps Flow happy.
    return (0, _d3Format.format)('.3s')(value).replace(insignificantZeroMatcher, '$1').replace(insignificantDecimalMatcher, '');
  }

  /** Leaves small integers as is */
  if (Number.isInteger(value)) {
    return value;
  }

  /** Formats small floating values to 2 decimal points */
  return (0, _d3Format.format)('.2f')(value);
};
var _default = exports["default"] = defaultNumberFormatter;
//# sourceMappingURL=defaultNumberFormatter.js.map